import React from 'react';

const InformationRow = props => {
  const { label, children } = props;

  return (
    <div className={'details-row'}>
      <span className={'label'}>{label}：</span>
      <span className={'bold'}>{children}</span>
    </div>
  );
};

export default InformationRow;